import {Button, Form, FormControl, InputGroup} from "react-bootstrap";
import React, {useState} from "react";


export default function SearchField({onSearch}){

    const [searchQuery, setSearchQuery] = useState('');
    const [searchTimingHook, setSearchTimingHook] = useState(undefined);

    const handleTypingSearch = e=>performSearch(e.target.value);

    const handleSearch = (e)=>{

        e.preventDefault();
        e.stopPropagation();

        const form = e.currentTarget;

        performSearch(form.elements['searchField'].value);
    }

    function performSearch(query){
        clearTimeout(searchTimingHook);

        const hook = setTimeout(
            function(){
                setSearchQuery(query);
                onSearch(query);
            }, 400
        )

        setSearchTimingHook(hook)
    }


    return (
        <Form onSubmit={handleSearch} >
            <InputGroup className="mb-3 ">
                <FormControl
                    placeholder="wpisz szukaną frazę"
                    aria-label="search placeholder"
                    aria-describedby="seach_field"
                    name={"searchField"}
                    onChange={handleTypingSearch}
                    defaultValue={searchQuery}
                />
                <Button type={"submit"} variant="outline-secondary" id="button-addon2">
                    Szukaj
                </Button>
            </InputGroup>
        </Form>
    )
}